<template>
  <div>
    <upload-files-v-2 type="image" :multiple="false" :allowedImageTypes="supportedImageTypes.formats" id="'headerImage'" ref="headerImage" :maxFileSizeAllowed="maxImageFileSize" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload"> </upload-files-v-2> 
    <upload-files-v-2 type="video" :multiple="false" :allowedVideoTypes='supportedVideoTypes.formats' :maxFileSizeAllowed="maxVideoFileSize"  id="'headerVideo'" ref="headerVideo" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload"> </upload-files-v-2>
    <div class="flex-between">
      <div v-if="isbroadcastCarousel && carousel_type == 'richcard'" class="flex100P">
        <p class="sub-title ion-no-margin paddingBottom flex100P">Layout</p>
        <VSelect v-model="selectedLayout" :disabled="isViewOnlyMode" aria-label="layout" appearance="ghost" class="vivid-input" fixed-dropdown>
          <VOption value="vertical" text="Vertical" />
          <VOption value="horizontal" text="Horizontal" />
        </VSelect>
      </div>
      <div v-if="isbroadcastCarousel && selectedLayout == 'vertical'" class="flex100P">
        <p class="sub-title ion-no-margin paddingBottom flex100P">Media height</p>
        <VSelect v-model="height" :disabled="isViewOnlyMode" aria-label="media_height" appearance="ghost" class="vivid-input" fixed-dropdown>
          <VOption value="short" text="Short" />
          <VOption value="medium" text="Medium" />
          <VOption value="tall" text="Tall" />
        </VSelect>
      </div>
      <div v-if="isbroadcastCarousel && carousel_type == 'richcard' && selectedLayout == 'horizontal'" class="flex100P">
        <p class="sub-title ion-no-margin paddingBottom flex100P">Media alignment</p>
        <VSelect v-model="media_alignment" :disabled="isViewOnlyMode" aria-label="media_aligment" appearance="ghost" class="vivid-input" fixed-dropdown>
          <VOption value="left" text="Left" />
          <VOption value="right" text="Right" />
        </VSelect>
      </div>
    </div>
    <div v-if="!isbroadcastCarousel" class="carouselIconContainer"  :class="{ 'whatsappCarousel': !isbroadcastCarousel }">
      <div >
        <p class="title ion-no-margin paddingBottom">Cards</p>
        <h2 class="sub-title ion-no-margin">Create your carousel</h2>
      </div>
      <div class="hide-md-up">
        <button class="nav-btn" @click="slidePrev()" :disabled="!isEnablePrevButton">
          <VIcon :name="chevronBackOutline"></VIcon>
        </button>
        <button class="nav-btn" @click="slideNext()" :disabled="!isEnableNextButton">
          <VIcon :name="chevronForwardOutline"></VIcon>
        </button>
      </div>
    </div>
    <!-- Multiple Carousels or single vertical Rich card -->
    <div v-if="selectedLayout == 'vertical' || carousel_type == 'carousel'" class="carousel-grid">
      <div class="carousel-row">
        <div v-if="carousel_type == 'carousel'" class="carousel-nav-col hide-md-down">
          <button class="nav-btn" @click="slidePrev()" :disabled="!isEnablePrevButton">
            <VIcon :name="chevronBackOutline"></VIcon>
          </button>
        </div>
        <div class="carousel-main-col">
          <div class="carousel-container">
            <div
              ref="carouselTrack"
              class="carousel-track"
              :class="{ 'is-grabbable': isEnablePrevButton || isEnableNextButton }"
              role="group"
              tabindex="0"
              aria-label="Carousel cards"
              @scroll="onTrackScroll"
            >
              <div v-for="(carousel, index) in carousel_message_json.CAROUSEL.cards" :key="index" :id="'carousel-container' + index" class="carousel-track-slide">
                <div class="singleCarouselCard" :class="{ 'singleCarouselCard_Active': activeSlideIndex === index }">
                  <div class="img-block cursorPointer" :class="['img-block', mediaHeightClass]">
                    <div v-if="carousel.components[0].image_url && !carousel.components[0].filesUploading" class="h-100">
                      <div v-if="!isbroadcastCarousel" class="h-100">
                        <img v-if="(carousel.components[0].format.toLowerCase() === 'image') && !isbroadcastCarousel" :src="carousel.components[0].image_url" width="200" @click="modifyFileUpload(index)" :class="{ 'carouselImage': true, 'disabledContainer': isViewOnlyMode }" alt="img_uploaded" />    
                        <template v-else>
                          <div v-if="isBrowserPlayableVideoUrl(carousel.components[0].image_url)" class="video-wrapper">
                            <video :src="carousel.components[0].image_url" width="200" controls preload="metadata" @click.stop :class="{ 'carouselImage': true, 'disabledContainer': isViewOnlyMode }"></video>
                            <button v-if="!isViewOnlyMode" class="replace-media-btn" @click.stop="modifyFileUpload(index)" title="Replace media">
                              <VIcon name="refresh-line" :size="-5" />
                            </button>
                          </div>
                          <div v-else class="carousel_videoFallback" @click="modifyFileUpload(index)" :class="{ 'carouselImage': true, 'disabledContainer': isViewOnlyMode }"> 
                            <VideoFallback :url="carousel.components[0].image_url" width="100%" height="100%" borderRadius="0px" />
                          </div>
                        </template>
                      </div>
                      <div v-else class="h-100">
                        <!-- Show placeholder for dynamic URLs -->
                        <div v-if="carousel.components[0]?.extrainfo?.url_type === 'dynamic'" class="dynamic-url-placeholder" @click="modifyFileUpload(index)" :class="{ 'disabledContainer': isViewOnlyMode }">
                          <VIcon :name="carousel.components[0]?.extrainfo?.media_type.toLowerCase() === 'image' ? imageOutline : videocamOutline" class="dynamic-placeholder-icon"></VIcon>
                          <p class="dynamic-url-label">Dynamic {{ carousel.components[0]?.extrainfo?.media_type.toLowerCase() === 'image' ? 'Image' : 'Video' }} will be disaplayed here</p>
                        </div>
                        <!-- Show actual media for static URLs -->
                        <template v-else>
                          <img v-if="carousel.components[0]?.extrainfo?.media_type.toLowerCase() === 'image'" :src="carousel.components[0].image_url" width="200" @click="modifyFileUpload(index)" :class="{ 'carouselImage': true, 'disabledContainer': isViewOnlyMode }" alt="video_uploaded" />    
                          <template v-else>
                            <div v-if="isBrowserPlayableVideoUrl(carousel.components[0].image_url)" class="video-wrapper">
                              <video :src="carousel.components[0].image_url" width="200" controls preload="metadata" @click.stop :class="{ 'carouselImage': true, 'disabledContainer': isViewOnlyMode }"></video>
                              <button v-if="!isViewOnlyMode" class="replace-media-btn" @click.stop="modifyFileUpload(index)" title="Replace media">
                                <VIcon name="refresh-line" :size="-5" />
                              </button>
                            </div>
                            <div v-else class="carousel_videoFallback"  @click="modifyFileUpload(index)" :class="{ 'carouselImage': true, 'disabledContainer': isViewOnlyMode }">
                              <VideoFallback :url="carousel.components[0].image_url" width="100%" height="100%" borderRadius="0px" />
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                    <div v-else class="img-container">
                      <div v-if="carousel.components[0].filesUploading" class="spinner text-center">
                        <VProgressRing connotation="cta" :size="-4" />
                      </div>
                      <div v-else @click="modifyFileUpload(index)" >
                        <div class="text-center flex-container paddingBottom" :class="{ 'disabledContainer': isViewOnlyMode }">
                          <VIcon :name="filmOutline"></VIcon>
                          <span class="title">Add image / video</span>
                        </div>
                        <p v-if="!isbroadcastCarousel" class="text-center sub-title paddingBottom uploadText">Image: Max file size 5MB {{ supportedImageTypes.message }}</p>
                        <p v-if="!isbroadcastCarousel" class="text-center sub-title uploadText">Video: Max file size 16MB {{ supportedVideoTypes.message }}</p>
                      </div>
                    </div>
                  </div>
                  <div v-if="isbroadcastCarousel" class="borderTop titleContainer">
                    <RichTextBoxV2
                      ref="titleEditor"
                      :value="carousel.components[1].title"
                      :showSmiley="!isViewOnlyMode"
                      :showCustomFiledInsertion="true"
                      :maxLength="200"
                      :readonly="isViewOnlyMode"
                      :showBotVariable="showBotVariable"
                      @input="(prop) => carousel.components[1].title = prop"
                      class="carouselMargin title width100P"
                      contentType="TEXT"
                    />

                    <RichTextBoxV2
                      ref="descriptionEditor"
                      :value="carousel.components[1].subtitle"
                      :showSmiley="!isViewOnlyMode"
                      :showCustomFiledInsertion="true"
                      :maxLength="2000"
                      :readonly="isViewOnlyMode"
                      :showBotVariable="showBotVariable"
                      @input="(prop) => carousel.components[1].subtitle = prop"
                      class="carouselSubtitleMargin title width100P"
                      :class="{ 'custom_mrg_bottom': carousel.components[2].buttons.length === 0 }"
                      contentType="TEXT"
                    />
                  </div>
                  <div v-else class="borderTop paddingBottom">
                    <my-input
                      textarea
                      id="post-text"
                      :emoji="!isViewOnlyMode"
                      name="post-text"
                      class="carouselInput overflow_emoji"
                      :lengthCounter="true"
                      :value="carousel.components[1].text"
                      @onInput="(prop) => { carousel.components[1].text = preserveLineBreaks(prop);}"
                      placeholder="Enter Message"
                      :maxlength="160"
                      :rows="2"
                      :disabled="isViewOnlyMode"
                      :lengthStyle="{left: '10px', bottom: '9px'}"
                      :iconStyle="{bottom: '3px'}"
                    />
                  </div>
                </div>
                <div>
                  <div v-for="(thisButton, bIndex) in carousel.components[2].buttons" :key="bIndex" @click="parseButtonInfo(thisButton, bIndex, index)" class="bttnContainer cursorPointer" :class="{ 'activeButton' : (index + '-' + bIndex) === activeButtonIndex, 'disabledContainer': isViewOnlyMode }">
                    <div class="button-text-container">
                      <VIcon v-if="thisButton?.action !== undefined || thisButton?.type !== undefined" :name="getIconForButton(thisButton)" connotation="cta"></VIcon>
                        <span class="bttnTitle ion-no-margin">{{ thisButton?.text }}</span>
                    </div>
                  </div>
                  <div class="add-multiple-carousel-bttn" v-if="isbroadcastCarousel ? carousel.components[2].buttons.length < 4 : carousel.components[2].buttons.length < 2" @click="addNewButtonToCarousel(index)" :disabled="isViewOnlyMode">
                    <button class="add-new-carousel-btn" :disabled="isViewOnlyMode">
                      <VIcon :name="addOutline" :size="-6" style="padding-right: 5px;"></VIcon>
                      Add new
                    </button>
                  </div>
                </div>

                <button v-if="carousel_type == 'carousel' && carousel_message_json.CAROUSEL.cards.length > 1" class="deleteCarouselButton" @click="deleteCarouselCard(index)" :disabled="isViewOnlyMode">
                  <VIcon :name="trashOutline" connotation="alert"></VIcon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="carousel_type == 'carousel'" class="carousel-nav-col hide-md-down">
          <button class="nav-btn" @click="slideNext()" :disabled="!isEnableNextButton">
            <VIcon :name="chevronForwardOutline"></VIcon>
          </button>
        </div>
      </div>
    </div>
     <!-- single horizontal rich card with left and right media alignment-->
    <div v-else-if="selectedLayout == 'horizontal' && carousel_type == 'richcard'" class="ion-no-padding margin40P">
      <div v-for="(carousel, index) in carousel_message_json.CAROUSEL.cards" class="rcs-rich-card" :class="media_alignment === 'right' ? 'rightRichCard' : ''">
        <div class="card-container">
          <div class="image-container rcsContainer">
            <div v-if="carousel.components[0].image_url && !carousel.components[0].filesUploading">
              <!-- Show placeholder for dynamic URLs in horizontal layout -->
              <div v-if="carousel.components[0]?.extrainfo?.url_type === 'dynamic'" class="dynamic-url-placeholder horizontal" @click="modifyFileUpload(index)" :class="{ 'disabledContainer': isViewOnlyMode }">
                <VIcon :name="carousel.components[0]?.extrainfo?.media_type.toLowerCase() === 'image' ? imageOutline : videocamOutline" class="dynamic-placeholder-icon-sm"></VIcon>
              </div>
              <!-- Show actual media for static URLs -->
              <template v-else>
                <div v-if="carousel.components[0]?.extrainfo?.media_type.toLowerCase() === 'image'">
                  <img :src="carousel.components[0].image_url" width="200" @click="modifyFileUpload(index)" :class="{ 'richCardcarouselImage': true, 'disabledContainer': isViewOnlyMode }" alt="rich_carduploaded" />    
                </div>
                <div v-else>
                  <div v-if="isBrowserPlayableVideoUrl(carousel.components[0].image_url)" class="video-wrapper">
                    <video :src="carousel.components[0].image_url" width="200" controls preload="metadata" @click.stop :class="{ 'richCardcarouselImage': true, 'disabledContainer': isViewOnlyMode }"></video>
                    <button v-if="!isViewOnlyMode" class="replace-media-btn" @click.stop="modifyFileUpload(index)" title="Replace media">
                      <VIcon name="refresh-line" :size="-5" />
                    </button>
                  </div>
                  <div v-else class="carousel_videoFallback" @click="modifyFileUpload(index)" :class="{ 'richCardcarouselImage': true, 'disabledContainer': isViewOnlyMode }">
                    <VideoFallback :url="carousel.components[0].image_url" width="100%" height="100%" :showIcon="false" borderRadius="0px" />
                  </div>
                </div>
              </template>
            </div>
            <div v-else class="img-container">
              <div @click="modifyFileUpload(index)" >
                <div class="text-center add-media" :class="{ 'disabledContainer': isViewOnlyMode }">
                  <VIcon :name="filmOutline" class="paddingBottom commonIcon"></VIcon>
                  <span class="title">Add image / video</span>
                </div>
              </div>
            </div>
          </div>          
          <div class="content-container">
            <div class="input-container">
              <div class="title-container">
                <RichTextBoxV2
                  ref="richCardTtleEditor"
                  :value="carousel.components[1].title"
                  :showSmiley="!isViewOnlyMode"
                  :showCustomFiledInsertion="true"
                  :maxLength="200"
                  :readonly="isViewOnlyMode"
                  :showBotVariable="showBotVariable"
                  @input="(prop) => carousel.components[1].title = prop"
                  class="title carouselSubtitleMargin width100P"
                  contentType="TEXT"
                />
              </div>
              <div class="description-container">
                <RichTextBoxV2
                  ref="richCardDescriptionEditor"
                  :value="carousel.components[1].subtitle"
                  :showSmiley="!isViewOnlyMode"
                  :showCustomFiledInsertion="true"
                  :maxLength="2000"
                  :readonly="isViewOnlyMode"
                  :showBotVariable="showBotVariable"
                  @input="(prop) => carousel.components[1].subtitle = prop"
                  class="carouselSubtitleMargin title width100P"
                  :class="{ 'custom_mrg_bottom': buttons.length === 0 }"
                  contentType="TEXT"
                />
              </div>
            </div>
            <div>
              <div v-for="(thisButton, bIndex) in carousel.components[2].buttons" :key="bIndex" @click="parseButtonInfo(thisButton, bIndex, index)" class="bttnContainer cursorPointer" :class="{ 'activeButton' : (index + '-' + bIndex) === activeButtonIndex, 'disabledContainer': isViewOnlyMode }">
                <div class="button-text-container">
                  <VIcon v-if="thisButton?.action !== undefined || thisButton?.type !== undefined" :name="getIconForButton(thisButton)" connotation="cta"></VIcon>
                  <span class="bttnTitle ion-no-margin">{{ thisButton?.text }}</span>
                </div>
              </div>
              <div class="add-button-container" v-if="isbroadcastCarousel ? carousel.components[2].buttons.length < 4 : carousel.components[2].buttons.length < 2" @click="addNewButtonToCarousel(index)" :disabled="isViewOnlyMode">
                <button class="add-new-carousel-btn" :disabled="isViewOnlyMode">
                  <VIcon :name="addOutline" :size="-6" style="padding-right: 5px;"></VIcon>
                  Add new
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shouldShowPopper" class="popperContainer">
      <popper :type="openPopper" :showDynamicURL="showDynamicURLOption" :channel="isbroadcastCarousel ? 'googlercs' : 'whatsapp'" :is_agent_or_group_req="true" :deleteButton="true" :isCarousel="true" :config="popperConfig" @submit="popperSubmit" @deleteBttn="removeButton"/>
    </div>
    <div class="suggestion_container">
      <suggestionChips v-if="isbroadcastCarousel" :selectedLayout="selectedLayout" :carousel_type="carousel_type" :carousel_messages="carousel_message_json.CAROUSEL" :isViewOnlyMode="isViewOnlyMode" ref="suggestionChips" @finalChipsData="finalChipsData" />
    </div>

    <div v-if="selectedLayout == 'vertical' && carousel_type == 'carousel'" class="carouselPaginationContainer flex-container">
      <div class="carousel-pagination">
        <span class="carousel-cards">
            <a v-for="(carousel, index) in carousel_message_json.CAROUSEL.cards" :key="index" :id="'carousel-item' + index" class="carousel-item" @click="navigateToSlide(index)">
                <img v-if="activeSlideIndex === index" :class="{ 'active': activeSlideIndex === index }" src="../../resources/images/carousel_card_active.svg" alt="carousel_active"/>
                <img v-else src="../../resources/images/carousel_card_inactive.svg" alt="carousel_inactive" />
            </a>
        </span>
        <span v-if="carousel_message_json.CAROUSEL.cards.length < 10" :class="{ 'disabledContainer': isViewOnlyMode}">
          <VIcon @click="addNewCarouselCard()" name="fax-add-solid" class="cursorPointer" style="padding-bottom: 4px; padding-left: 5px; font-size: 13px"></VIcon>
        </span>
      </div>
    </div>
  </div> 
  <!-- Upload Media Dialog (Image/Video tabs) -->
  <VDialog :open="openInputSelection || openImageFileUploadModal || openVideoFileUploadModal" modal @close="() => { openInputSelection = false; openImageFileUploadModal = false; openVideoFileUploadModal = false; }" headline="Upload Media" style="--dialog-min-inline-size: 450px; --dialog-max-inline-size: 500px;">
    <template #body>
      <div class="custom-tabs upload-tabs">
        <div class="custom-tab" :class="{ active: uploadTab === 'image' }" @click="() => { uploadTab = 'image'; selectedInputType = 'IMAGE'; }">
          <VIcon name="image-line" :size="-5" style="margin-right: 4px;" />
          <span>Image</span>
        </div>
        <div class="custom-tab" :class="{ active: uploadTab === 'video' }" @click="() => { uploadTab = 'video'; selectedInputType = 'VIDEO'; }">
          <VIcon name="video-line" :size="-5" style="margin-right: 4px;" />
          <span>Video</span>
        </div>
      </div>
      <div style="padding-top: 16px;">
        <!-- Image Upload Tab -->
        <div v-if="uploadTab === 'image'">
          <upload-files-v-2 uploadURLEnabled
            :allowDynamicURL="isbroadcastCarousel"
            :isViewOnlyMode="isViewOnlyMode"
            :allowedImageTypes="supportedImageTypes.formats"
            @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData)"
            type="image" :multiple="false" id="'carouselImage'" ref="carouselImage" :maxFileSizeAllowed="100" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload">
            <div class="paddingBottom">
              <div class="info-box">
                <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                <p class="title ion-no-margin">Max file size 100MB {{ supportedImageTypes.message }}</p>
              </div>
              <VButton :disabled="filesUploading || isViewOnlyMode" class="vvd-btn-secondary vvd-btn-block custom_mrg_bottom" connotation="cta" appearance="outlined" label="Upload Image" icon="image-line" :pending="filesUploading" />
            </div>
          </upload-files-v-2>
        </div>
        <!-- Video Upload Tab -->
        <div v-if="uploadTab === 'video'">
          <upload-files-v-2 uploadURLEnabled
            :allowDynamicURL="isbroadcastCarousel"
            :isViewOnlyMode="isViewOnlyMode"
            :allowedVideoTypes="supportedVideoTypes.formats"
            @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData)"
            type="video" :multiple="false" id="'headerVideo'" ref="headerVideo" :maxFileSizeAllowed="100" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload">
            <div class="paddingBottom">
              <div class="info-box">
                <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                <p class="title ion-no-margin">Max file size 100MB {{ supportedVideoTypes.message }}</p>
              </div>
              <VButton :disabled="filesUploading || isViewOnlyMode" class="vvd-btn-secondary vvd-btn-block custom_mrg_bottom" connotation="cta" appearance="outlined" label="Upload Video" icon="video-line" :pending="filesUploading" />
            </div>
          </upload-files-v-2>
        </div>
      </div>
    </template>
  </VDialog>
</template>

<script>

import popper from '@/components/popper.vue';
import uploadFilesV2 from "@/components/uploadFilesV2.vue";
import suggestionChips from "@/components/suggestion-chips.vue";
import { getIcon } from '@/helpers/icon.helper';
import { getVideoMimeType, isBrowserPlayableVideoUrl } from '@/helpers/video.helpers';
import VideoFallback from '@/components/VideoFallback.vue';
import RichTextBoxV2 from '@/components/rich-text-box-v2.vue';
import messageTags from '@/resources/data/message-tags.json';
import { useUIStore } from '@/stores/ui';
import { enableDragScroll, getScrollNavigationState, rafThrottle, scrollTrackByOneSlide, scrollTrackToSlide } from '@/helpers/carousel.helpers';

export default {
  mixins: [],
  emits: ["finalCarouselData"],
  components: {
    popper,
    uploadFilesV2,
    suggestionChips,
    RichTextBoxV2,
    VideoFallback
  },
  props: {
    carousel_type: {
      type: String,
      default: 'carousel'
    },
    carouselData: {
      type: Object,
      default: function () {
        return {
          BODY: {
						text: ""
          },
          CAROUSEL: {
              cards: [],
              buttons: [],
          }
        };
      },
    },
    showBotVariable: {
      type: Boolean,
      default: true
    },
    isbroadcastCarousel: {
      type: Boolean,
      default: false
    },
    broadcastCarouselSize: {
      type: Number,
      default: 5
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false
    },
    enableURLUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imageOutline: 'image-line',
      videocamOutline: 'video-line',
      informationCircleOutline: 'info-line',
      filmOutline: 'media-player-line',
			chevronBackOutline: 'chevron-left-line',
      addOutline: 'plus-line',
			chevronForwardOutline: 'chevron-right-line',
			trashOutline: 'delete-line',
      callOutline: 'call-line',
      openOutline: 'open-line',
      copyOutline: 'copy-2-line',
      arrowUndoOutline: 'undo-solid',
      close: 'close-line',
      chevronDownOutline: 'chevron-down-line',
      openPopper: undefined,
			popperIndex: -1,
      popperConfig: {
				text: undefined,
				action: undefined,
				payload: undefined,
        extrainfo: undefined
			},
      carousel_message_json: { ...this.carouselData },
      filesUploading: false,
			onTrackScroll: null,
			teardownDragScroll: null,
			isEnablePrevButton: false,
      isEnableNextButton: true,
			selectedInputType: '',
			activeSlideIndex: 0,
      openInputSelection: false,
      inputOptions: [
				{
          text: "Image",
          handler: () => {
						this.selectedInputType = 'IMAGE';
            if (this.enableURLUpload) {
              this.openImageFileUploadModal = true;
            } else {
              this.$refs.headerImage.openFileInput();
            }
          }
        },
        {
          text: 'Video',
          handler: () => {
						this.selectedInputType = 'VIDEO';
            if (this.enableURLUpload) {
              this.openVideoFileUploadModal = true;
            } else {
              this.$refs.headerVideo.openFileInput();
            }
          }
        },
			],
      carouselIndex: -1,
      activeButtonIndex: null,
      openImageFileUploadModal: false,
      openVideoFileUploadModal: false,
      uploadTab: 'image',
      selectedLayout: 'vertical',
      buttons: [],
      media_alignment: 'left',
      height: 'medium',
      finalSuggestionChipsData: [],
      media_type: 'IMAGE',
      simpleMessageTags: [],
      enableDynamicURL: false
    };
  },
  created() {
    this.onTrackScroll = rafThrottle(this.slidNavigationHandler);
  },
  mounted() {
    window.addEventListener('resize', this.onTrackScroll);
    this.setMessageTags();
    this.finalSuggestionChipsData = [];
    const carouselCards = this.carousel_message_json.CAROUSEL.cards;
    const cardCount = Object.keys(carouselCards).length;
    if (this.isbroadcastCarousel && this.selectedLayout === 'vertical' && cardCount === 0) {  // adding Default single carousel card for googlercs
      this.addNewCarouselCard();
    }
    if (cardCount > 2) {  // Navigating To middle Carousel
      this.navigateToSlide(1);
    }
    if (cardCount > 0 && this.isbroadcastCarousel) { // assigning richcard values
      this.assignRichCardValues();
    }
    this.$nextTick(() => {
      this.slidNavigationHandler();
      this.teardownDragScroll = enableDragScroll(this.$refs.carouselTrack);
    });
  },
  updated() {
    // Re-evaluate nav state after cards are added, removed or re-rendered.
    this.onTrackScroll();
    // The track is behind a v-if, so it can mount after this component does.
    this.teardownDragScroll = enableDragScroll(this.$refs.carouselTrack);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onTrackScroll);
    this.onTrackScroll?.cancel();
    this.teardownDragScroll?.();
  },
  watch: {
    filesUploading(newVal) {
      this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[0].filesUploading = newVal;
    },
    media_alignment(newVal) {
      this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo.thumbnail_alignment = newVal;
    },
    selectedLayout(newVal) {
      this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo.card_orientation = newVal;
    },
    height(newVal) {
      // Apply height to all carousel cards for broadcast carousel
      this.carousel_message_json.CAROUSEL.cards.forEach(card => {
        if (card.components[0].extrainfo) {
          card.components[0].extrainfo.height = newVal;
        }
      });
    },
    media_type(newVal){
      this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo.media_type = newVal;
    }
  },
  computed: {
		shouldShowPopper(){
			return this.openPopper === 'detailed'
		},
    showDynamicURLOption() {
      return !this.isbroadcastCarousel;
    },
    supportedImageTypes() {
      if(this.isbroadcastCarousel) {
        return {
          formats: 'image/png, image/jpeg, image/jpg, image/gif',
          message: '(.jpg, .png, or .gif only)'
        }
      } else {
        return {
          formats: 'image/png, image/jpeg, image/jpg',
          message: '(.jpg, or .png only)'
        }
      } 
    },
    supportedVideoTypes() {
      if(this.isbroadcastCarousel) {
        return {
          formats: 'video/mp4, video/mpeg, video/mpeg4, video/m4v, video/webm',
          message: '(.mp4, .mpeg, .mpeg4, .m4v, or .webm only)'
        }
      } else {
        return {
          formats: 'video/mp4',
          message: '(.mp4 only)'
        }
      } 
    },
    maxImageFileSize() {
      if(this.isbroadcastCarousel) {
        return this.broadcastCarouselSize;
      } else {
        return 5
      } 
    },
    maxVideoFileSize() {
      if(this.isbroadcastCarousel) {
        return this.broadcastCarouselSize;
      } else {
        return 16
      } 
    },
    mediaHeightClass() {
      return {
        short: 'img-block-short',
        medium: 'img-block-medium', // Default
        tall: 'img-block-tall'
      }[this.height] || 'img-block-medium';
    }
	},
  methods: {
    setMessageTags(){
      this.simpleMessageTags = messageTags?.allChannelsMessageTags?.filter(({tag}) => ['userfirstname', 'userlastname', 'useremail', 'userphone'].includes(tag));
    },
		async handleFilesUpload (urlData) {
      try {
        this.filesUploading = true;
        // Derive format from the upload response mime_type (source of truth from the API).
        // Falls back to selectedInputType when mime_type is absent so video uploads
        // without a mime_type in the response are still classified correctly.
        const mimeType = urlData[0]?.mime_type || '';
        const formatFromMime = mimeType.startsWith('video/') ? 'VIDEO' : 'IMAGE';
        const format = mimeType ? formatFromMime : this.selectedInputType;
        let carouselJson = this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[0];
				carouselJson.format = format;
				carouselJson.example = urlData[0].url;
        carouselJson.image_url = urlData[0].url;
        if(this.isbroadcastCarousel) {
          this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[0].extrainfo.media_type = format;
        }
        const toastMessage = format === 'VIDEO'
          ? "Video uploaded successfully!" 
          : "Image uploaded successfully!";
        useUIStore().updateToast({ open: true, message: toastMessage, type: "success" });
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.filesUploading = false;
        this.openInputSelection = false;
        this.openImageFileUploadModal = false;
        this.openVideoFileUploadModal = false;
      }
    },
    modifyFileUpload(cardIndex) {
      this.carouselIndex = cardIndex;
      this.openInputSelection = true;
    },
    addNewCarouselCard(){
      let jsonData = {
        "components": [
          {
            "type": "HEADER",
            "format": "",
            "example": "",
            "image_url": "",
            "filesUploading": false,
          },
          {
            "type": "BODY",
            "text": ""
          },
          {
            "type": "BUTTONS",
            "buttons": []
          }
        ]
      };
      if (this.isbroadcastCarousel) {
        jsonData.components.forEach((component) => { // For Broadcast Googlercs Carousel we are adding single button by Default
          if (component.type === "BODY") { // For Broadcast Googlercs Carousel we are adding title, subtile by default
            component.title = "Title";
            component.subtitle = "Description";
            delete component.text;
          } else if(component.type === 'HEADER'){
            component.extrainfo = {
              media_type: this.media_type,
              height: this.height,
              url_type: 'static',
            };
          }
        });
        if(this.carousel_type == 'richcard'){
          jsonData.components = jsonData.components.map(component => {
            if (component.type === "HEADER") {
              return {
                ...component,
                extrainfo: {
                  card_orientation: this.selectedLayout,
                  thumbnail_alignment: this.media_alignment,
                  height: this.height,
                  media_type: this.media_type,
                  url_type: 'static'
                }
              };
            }
            return component;
          });
        }
      }
      let carouselCards = this.carousel_message_json.CAROUSEL.cards;
      carouselCards.push(jsonData);

       // Add CAROUSEL.buttons array for suggestion replies and actions 
      if (!Array.isArray(this.carousel_message_json.CAROUSEL.buttons)) {
        this.carousel_message_json.CAROUSEL.buttons = [];
      }

      let newIndex = carouselCards.length - 1; // Navigate to the newly added slide
      this.navigateToSlide(newIndex);
    },
    deleteCarouselCard(cardIndex){
      if(this.carousel_message_json.CAROUSEL.cards.length > 1){
        this.carousel_message_json.CAROUSEL.cards.splice(cardIndex, 1);
      }
      else{
        useUIStore().updateToast({ open: true, message: `You can't delete this card`, type: "danger" });
      }
    },
		slidNavigationHandler() {
      const { isEnablePrevButton, isEnableNextButton } = getScrollNavigationState(this.$refs.carouselTrack);
      this.isEnablePrevButton = isEnablePrevButton;
      this.isEnableNextButton = isEnableNextButton;
    },
    slideNext() {
      scrollTrackByOneSlide(this.$refs.carouselTrack, 1);
    },
    slidePrev() {
      scrollTrackByOneSlide(this.$refs.carouselTrack, -1);
    },
    navigateToSlide(index) {
			this.activeSlideIndex = index;
      // Wait for the slide to exist in the DOM (e.g. right after adding a card).
      this.$nextTick(() => scrollTrackToSlide(this.$refs.carouselTrack, index));
    },
		addNewButtonToCarousel(cardIndex){
      this.carousel_message_json.CAROUSEL.cards[cardIndex].components[2].buttons.push({ text: this.isbroadcastCarousel ? 'Suggestion' : 'Button', type: undefined, payload: undefined });
    },
    popperSubmit(result) {
      const data = result.new;
      const button = this.carousel_message_json.CAROUSEL.cards[this.carouselIndex]?.components[2]?.buttons[this.popperIndex];
      
			if (this.popperIndex > -1 && button) {
        // Set common properties for all button types
        Object.assign(button, {
          text: data.text,
          payload: data.payload,
          postback_action_type: data.postback_action_type,
          postback_action: data.postback_action
        });

        // Handle action-specific properties
        switch (data.action) {
          case 'location':
            button.type = 'location';
            button.extrainfo = data.extrainfo;
						break;
          case 'share':
            button.type = 'share';
						break;
          case 'calendar':
            button.type = 'calendar';
            button.extrainfo = data.extrainfo;
						break;
          case 'phone_number':
            button.type = 'phone_number';
						break;
					case 'website':
            button.type = 'website';
            button.url = data.payload;
            button.url_type = data.url_type;
						break;
          case 'app_webview':
            button.type = 'app_webview';
            button.url = data.payload;
            button.url_type = data.url_type;
            button.extrainfo = data.extrainfo;
						break;
          case 'opt_in':
          case 'opt_out':
						button.type = this.isbroadcastCarousel ? 'postback' : 'QUICK_REPLY';
						break;
					default:
            button.type = 'QUICK_REPLY';
						break;
				}
			}
			
      this.openPopper = undefined;
			this.popperIndex = -1;
      this.carouselIndex = -1;
      this.activeButtonIndex = null;
		},
    parseButtonInfo(buttonInfo, bttnIndex, cardIndex){
      if(this.shouldShowPopper){
				return useUIStore().updateToast({ open: true, message: "Please save your changes to the current button before editing a new one.", type: "warning" })
			}
			this.openPopper = 'detailed'; // QuickReply buttons Popper
			this.popperIndex =  bttnIndex;
      this.carouselIndex = cardIndex;
			this.popperConfig = buttonInfo;
      this.activeButtonIndex = cardIndex + '-' + bttnIndex; // tracking indivudual Buttons
		},
    removeButton() {
			try {
				if(this.popperIndex > -1) {
          this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[2].buttons.splice(this.popperIndex, 1);
				}
			} catch (error) {
				console.error("Exception", error);
			} finally {
				this.openPopper = undefined;
				this.popperIndex = -1;
        this.carouselIndex = -1;
			}
		},
    processCarouselData(){
      this.$emit('finalCarouselData', this.carousel_message_json); 
    },
    handleUrlUpload(uploadedUrlData) {
      try {
        this.filesUploading = true;
        const uploadedUrl = typeof uploadedUrlData === 'string' ? uploadedUrlData : uploadedUrlData.file_url;
        const urlType = uploadedUrlData?.url_type || 'static';
        
        let carouselJson = this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[0];
				carouselJson.format = this.selectedInputType;
				carouselJson.example = uploadedUrl;
        carouselJson.image_url = uploadedUrl;
        if(this.isbroadcastCarousel) {
          this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[0].extrainfo.media_type = this.selectedInputType;
          this.carousel_message_json.CAROUSEL.cards[this.carouselIndex].components[0].extrainfo.url_type = urlType;
        }
        const toastMessage = this.openVideoFileUploadModal 
          ? "Video uploaded successfully!" 
          : "Image uploaded successfully!";
        useUIStore().updateToast({ open: true, message: toastMessage, type: "success" });
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.filesUploading = false;
        this.openInputSelection = false;
        this.openImageFileUploadModal = false;
        this.openVideoFileUploadModal = false;
      }
    },
    finalChipsData(data){
      this.finalSuggestionChipsData = data;
      // Adding Suggestion chips to carouselData
      this.carousel_message_json.CAROUSEL.buttons = this.finalSuggestionChipsData;
    },
    getIconForButton(button) {
      return getIcon(button);
    },
    assignRichCardValues() {
      this.media_alignment = this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo?.thumbnail_alignment.toLowerCase() || 'left';
      this.height = this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo?.height.toLowerCase() || 'medium';
      this.selectedLayout = this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo?.card_orientation.toLowerCase() || 'vertical';
      this.media_type = this.carousel_message_json.CAROUSEL.cards[0].components[0].extrainfo?.media_type.toLowerCase() || 'IMAGE';
    },
    preserveLineBreaks(text) {
      // Ensure line breaks are preserved as \n characters
      if (!text) return text;
      return text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    },
    getVideoMimeType,
    isBrowserPlayableVideoUrl,
  }
}
</script>

<style scoped lang="scss">

.carousel-pagination {
	border: 1px solid var(--background-primary);
	border-radius: 25px;
	padding: 10px;
	display: flex;
  align-items: center;
}
.carousel-cards{
	display: flex;
	gap: 5px;
}
.singleCarouselCard{
	border: 1px solid var(--gray-04);
	border-bottom: none;
	border-radius: 5px 5px 0px 0px;
	position: relative;
}
.singleCarouselCard_Active{
  border: 1px solid var(--purple);
  border-bottom: none;
}
.img-block{
	border-radius: 5px;
	background: var(--background-primary);
	display: flex;
	align-items: center;
	justify-content: center;
}
.img-block-short {
	height: 112px;
}
.img-block-medium {
	height: 168px;
}
.img-block-tall {
	height: 264px;
}
.carouselInput{
	border-radius: 5px;
	margin: 10px 10px 20px 7px;
	width: 95%;
}
.borderTop{
	border-top: 1px solid var(--gray-04);
}
.carouselImage{
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 5px 5px 0px 0px;
}
/* Video wrapper with replace button overlay */
.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.replace-media-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--gray-04);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  transition: background 0.2s;
}
.replace-media-btn:hover {
  background: var(--purple-opac);
  border-color: var(--purple);
}
.carousel-grid{
	margin-top: 30px;
}
.deleteCarouselButton {
	position: absolute;
	top: 0%;
	right: -5%;
	color: var(--orange);
	background: none;
	border: none;
	cursor: pointer;
	padding: 5px;
}
.deleteCarouselButton:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
.uploadText{
	margin: 0px 40px;
}
.flex-container{
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 5px;
}
/* Nav buttons */
.nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  color: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-btn:hover {
  background: var(--background-primary);
}
.nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.hide-md-up {
  display: none;
}
.hide-md-down {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .hide-md-up { display: block; }
  .hide-md-down { display: none; }
}
/* Carousel grid layout */
.carousel-row {
  display: flex;
  align-items: center;
  gap: 5px;
}
.carousel-nav-col {
  flex: 0 0 auto;
}
.carousel-main-col {
  flex: 1;
  min-width: 0;
}
/* Native scroll-snap carousel track */
.carousel-container {
  width: 100%;
}
.carousel-track {
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* Desktop: 3 cards per view, 10px apart, active card centred.
     The centred active card needs half of the off-screen width free on each side,
     i.e. (trackWidth - cardWidth) / 2 == (trackWidth + gap) / 3 of padding. Because
     the padding is inside the border box, what is left for a card is exactly
     (trackWidth - 2 * gap) / 3 -- so the slides below are simply `flex: 0 0 100%`.
     The padding is also what stops the track scrolling when the cards already fit. */
  gap: 10px;
  padding-left: calc((100% + 10px) / 3);
  padding-right: calc((100% + 10px) / 3);
}
/* grab cursor, shown only while the track actually has somewhere to scroll */
.carousel-track.is-grabbable {
  cursor: grab;
}
.carousel-track.is-grabbable[data-dragging] {
  cursor: grabbing;
}
.carousel-track::-webkit-scrollbar {
  display: none;
}
.carousel-track-slide {
  position: relative;
  flex: 0 0 100%;
  scroll-snap-align: center;
}
/* Mobile: 1 card per view, 5px apart. One card fills the track, so centring it
   needs no padding and start/centre alignment come out the same. */
@media (max-width: 767px) {
  .carousel-track {
    gap: 5px;
    padding-left: 0;
    padding-right: 0;
  }
}
/* Tablets: 2 cards per view, 10px apart, not centred. */
@media (min-width: 768px) and (max-width: 1023px) {
  .carousel-track {
    padding-left: 0;
    padding-right: 0;
  }
  .carousel-track-slide {
    flex: 0 0 calc((100% - 10px) / 2);
    scroll-snap-align: start;
  }
}
/* Add new button inside carousel */
.add-new-carousel-btn {
  background: none;
  border: none;
  color: var(--purple);
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 100%;
}
.add-new-carousel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/* Upload tabs inside dialog */
.upload-tabs {
  display: flex;
  border-bottom: 1px solid var(--background-primary);
  .custom-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    gap: 5px;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    color: var(--gray-04);
    &.active {
      color: var(--purple);
      font-weight: 600;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 20%;
        width: 60%;
        height: 2px;
        background-color: var(--purple);
        border-radius: 2px;
      }
    }
    &:hover:not(.active) {
      color: var(--black);
    }
  }
}
.bttnContainer{
	background: var(--white);
	border: 1px solid var(--purple);
	height: 50px;
	display: flex;
	align-items: center;
  justify-content: center;
}
.bttnContainer:last-child{
	border-radius: 0px 0px 5px 5px;
}
.bttnContainer:not(:last-child) {
  border-bottom: none;
}
.bttnContainer:hover{
	background: var(--purple-opac);
}
.bttnContainer:hover .bttnTitle{
	color: var(--purple);
}
.bttnContainer:hover .active_icon{
	color: var(--purple-opac);
}
.singleButtonPadding{
  padding-bottom: 7px;
}
.button-text-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.bttnTitle{
	color: var(--purple);
	font-size: 14px;
	font-weight: 400;
  line-height: 16px;
}
.popperContainer{
	margin: 20px 0px 30px 0px;
	border: 1px solid var(--background-primary);
	padding: 20px;
  border-radius: 5px;
}
.carouselPaginationContainer{
  margin: 0px 0px 20px 0px;
}
.carouselIconContainer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.whatsappCarousel{
  border-top: 1px solid var(--background-primary);
  padding-top: 20px;
}
.activeButton{
	background: var(--purple-opac);
}
.activeButton .bttnTitle, .active_icon{
	color: var(--purple) !important;
}
.custMargin {
  margin-bottom: 50px;
}
.titleContainer{
  padding: 10px;
}
.carouselMargin{
  margin: 0px 0px 10px 0px;
}
.carouselSubtitleMargin{
  margin: 0px;
}
.file-upload-header {
  font-size: 18px;
  font-style: normal;
  color: var(--black);
  font-weight: 400;
  line-height: 20px;
  padding-left: 20px;
}
.margin40P{
  margin: 40px 0px 20px 0px;
}
.add-multiple-carousel-bttn {
  display: flex;
  justify-content: center;
  border: 1px solid var(--purple);
  border-radius: 0px 0px 5px 5px;
}
ion-modal.file-upload-modal {
  --height: 290px;
  --width: 500px !important;
  --border-radius: 5px;
}
.rcs-rich-card {
  max-width: 350px;
  margin: 0 auto;

  .card-container {
    display: flex;
    border-radius: 5px;
    min-height: 280px;
    height: 100%;
  }

  .image-container {
    background-color: var(--background-primary);
    width: 30%;
    display: flex;
    align-items: center;
    min-height: 280px;
    border: 1px solid var(--gray-04);
    border-radius: 5px 0px 0px 5px;
  }

  .input-container {
    border: 1px solid var(--gray-04);
    border-radius: 0px 5px 0px 0px;
    margin-left: -1px;
    margin-bottom: -1px;
  }

  .add-media {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--black);
  }

  .description-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }

  .bttnContainer{
    margin-left: -1px;
  }

  .add-button-container {
    display: flex;
    justify-content: center;
    border: 1px solid var(--purple);
    margin-top: -1px;
    margin-left: -1px;
    border-radius: 0px 0px 5px 0px;
  }
  .custom_brdr{
    border: 1px solid var(--gray-04) !important;
  }
  .rcsContainer{
    position: relative;
    overflow: hidden;
  }
  .richCardcarouselImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
  .bttnContainer:last-child {
    border-radius: 0px 0px 5px 0px;
  }
  &.rightRichCard {
    .card-container {
      flex-direction: row-reverse;
    }
    .image-container {
      border-radius: 0px 5px 5px 0px
    }
    .input-container {
      margin-right: -1px;
      margin-bottom: -1px;
      border-radius: 5px 0px 0px 0px;
    }
    .add-button-container{
      border-radius: 0px 0px 0px 5px;
      margin-right: -1px;
    } 
    .bttnContainer {
      border-radius: 0px;
      margin-right: -1px;
    }
  }
}
.media-icon {
  margin-bottom: 10px;
}
.title-container {
  padding: 10px 10px 0px 10px;
  .jinput {
    width: 100%;
    font-size: 14px;
    border: 1px solid var(--gray-04);
  }
}
.jinput.textarea {
  border: 1px solid var(--gray-04);
}
.suggestion_container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.overflow_emoji {
  overflow: inherit !important;
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  background: var(--purple-opac);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  padding-left: 20px;
}
.justify-content{
  justify-content: space-between;
}
.width100P{
  width: 100% !important;
}
.content-container{
  width: 70%;
}
.dynamic-url-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: linear-gradient(135deg, var(--purple-opac) 0%, var(--gray-01) 100%);
  border-radius: 0px;
  padding: 28px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: linear-gradient(135deg, var(--purple) 0%, var(--purple-opac) 100%);
    border-color: var(--ion-color-primary);
  }
  &.horizontal {
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 0;
  }
  .dynamic-placeholder-icon {
    font-size: 48px;
    color: var(--purple);
    margin-bottom: 10px;
  }
  .dynamic-placeholder-icon-sm {
    font-size: 24px;
    color: var(--purple);
    margin-bottom: 5px;
  }
  .dynamic-url-label {
    font-size: 12px;
    color: var(--gray-05);
    text-align: center;
    margin: 0;
    font-style: italic;
  }
}
.carousel_videoFallback{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
}
.videoFallback {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: var(--background-primary);
  border-radius: 5px;
  padding: 16px;
  box-sizing: border-box;
  text-align: center;
}
.videoFallbackLink {
  color: var(--purple) !important;
  text-decoration: underline;
  font-size: 14px;
}
</style>